import { Notifications } from "expo";
import * as Permissions from "expo-permissions";
import { Platform } from "react-native";

const registerChannel = async () => {
  if (Platform.OS === "android") {
    Notifications.createChannelAndroidAsync("drinkalerts", {
      name: "drinkalerts",
      priority: "max",
      sound: true,
      vibrate: [0, 250, 250, 250]
    });
  }
};

export default async function registerForPushNotifications() {
  if(!['android', 'ios'].includes(Platform.OS)) {
    return
  }

  const { status: existingStatus } = await Permissions.getAsync(
    Permissions.NOTIFICATIONS
  );
  let finalStatus = existingStatus;

  // only ask if permissions have not already been determined, because
  // iOS won't necessarily prompt the user a second time.
  if (existingStatus !== "granted") {
    // Android remote notification permissions are granted during the app
    // install, so this will only ask on iOS
    const { status } = await Permissions.askAsync(Permissions.NOTIFICATIONS);
    finalStatus = status;
  }

  // Stop here if the user did not grant permissions
  if (finalStatus !== "granted") {
    return;
  }

  await registerChannel();

  // Get the token that uniquely identifies this device
  return await Notifications.getExpoPushTokenAsync();
}
